import {
  actionTypes,
  apiDatingPurposes,
  apiUserBadHabits,
  apiUserEyes,
  apiUserEducations,
  apiUserIncomes,
  apiUserHairs,
  apiBreastSize,
  apiSexPeriodicity,
  apiSexualOrientation,
} from "./usersTypes";

const safeParseJSON = (value: string | null | undefined, defaultValue: any = []): any => {
    if (!value || value === 'undefined' || value === '') {
      return defaultValue;
    }
    try {
      return JSON.parse(value);
    } catch (e) {
      console.error('Error parsing JSON from localStorage:', e, 'Value:', value);
      return defaultValue;
    }
};

const initialState = {
  usersIdsAll: [],
  // Пагинация выдачи (как SEARCH/SEARCH_MORE в RN): searchGen меняется только
  // на свежем поиске, hasMoreIds — бэк вернул полную страницу (= limit).
  searchGen: 0,
  hasMoreIds: false,
  loadingMoreIds: false,
  usersPreviews: [],
  pageCounter: 12,
  loadingFilter: false,
  loadingUsers: true,
  loadingCurrentUser: true,
  filter: {
    sex: null,
    income: [],
    hairColor: [],
    eyesColor: [],
    smoking: [],
    alcohol: [],
    education: [],
    children: null,
    interests: [],
    languages: [],
    cities: [],
    age: { from: 18, to: 100 },
    height: { from: 120, to: 240 },
    weight: { from: 40, to: 100 },
    idCountry: null,
    citizenships: [],
    datingPurpose: [],
    relationStatus: [],
    periodicity: [],
    sexTypes: [],
    breast: [],
    sexualOrientation: [],
  },
  selects: {
    educationList: [
      { name: "entities.secondary", id: apiUserEducations.Secondary },
      { name: "entities.gettingHigher", id: apiUserEducations.IncompleteHigher },
      { name: "entities.higher", id: apiUserEducations.Higher },
      { name: "entities.phD", id: apiUserEducations.PhD },
    ],
    incomeList: [
      { name: "entities.low", id: apiUserIncomes.Low },
      { name: "entities.averge", id: apiUserIncomes.Average },
      { name: "entities.high", id: apiUserIncomes.High },
      { name: "entities.veryHigh", id: apiUserIncomes.VeryHigh },
    ],
    hairColorList: {
      0: [
        { name: "entities.blondeHairMan", id: apiUserHairs.Blonde },
        { name: "entities.brunetteHairMan", id: apiUserHairs.Black },
        { name: "entities.brownHairMan", id: apiUserHairs.Brown },
        { name: "entities.redHairMan", id: apiUserHairs.Red },
      ],
      1: [
        { name: "entities.blondeHairWoman", id: apiUserHairs.Blonde },
        { name: "entities.brunetteHairWoman", id: apiUserHairs.Black },
        { name: "entities.brownHairWoman", id: apiUserHairs.Brown },
        { name: "entities.redHairWoman", id: apiUserHairs.Red },
      ],
    },
    eyesColorList: [
      { name: "entities.brown", id: apiUserEyes.Brown },
      { name: "entities.green", id: apiUserEyes.Green },
      { name: "entities.blue", id: apiUserEyes.Blue },
      { name: "entities.gray", id: apiUserEyes.Gray },
    ],
    languagesList: safeParseJSON(window.localStorage.languagesList, []),
    smokingList: [
      { name: "entities.negative", id: apiUserBadHabits.Negative },
      { name: "entities.tolerant", id: apiUserBadHabits.Tolerant },
      { name: "entities.neutral", id: apiUserBadHabits.Neutral },
      { name: "entities.positive", id: apiUserBadHabits.Positive },
    ],
    nationalitiesList: safeParseJSON(window.localStorage.nationalitiesList, []),
    interestsList: safeParseJSON(window.localStorage.interestsList, []),
    targetList: {
      0: [
        /* { name: "Свободные отношения", id: apiDatingPurposes.FreeRelationship }, */// TODO apple review
        {
          name: "entities.longTermRelationship",
          id: apiDatingPurposes.LongTermRelationship,
        },
        { name: "entities.lookingForSponsor", id: apiDatingPurposes.LookingForSponsor },// TODO apple review
        { name: "entities.justChatting", id: apiDatingPurposes.Chatting },
        { name: "entities.trips", id: apiDatingPurposes.Travel },
      ],
      1: [
        /* { name: "Свободные отношения", id: apiDatingPurposes.FreeRelationship }, */
        {
          name: "entities.longTermRelationship",
          id: apiDatingPurposes.LongTermRelationship,
        },
        { name: "entities.lookingForSponsor", id: apiDatingPurposes.LookingForSponsor },
        { name: "entities.justChatting", id: apiDatingPurposes.Chatting },
        { name: "entities.trips", id: apiDatingPurposes.Travel },
      ],
    },
    relationsList: {
      0: [
        { name: "entities.singleMan", id: apiDatingPurposes.FreeRelationship },
        { name: "entities.relationshipMan", id: apiDatingPurposes.LongTermRelationship },
        /* { name: "Женат", id: apiDatingPurposes.LookingForSponsor }, */
        { name: "entities.divorcedMan", id: apiDatingPurposes.Chatting },
      ],
      1: [
        { name: "entities.singleWoman", id: apiDatingPurposes.FreeRelationship },
        { name: "entities.relationshipWoman", id: apiDatingPurposes.LongTermRelationship },
        /* { name: "Замужем", id: apiDatingPurposes.LookingForSponsor }, */
        { name: "entities.divorcedWoman", id: apiDatingPurposes.Chatting },
      ],
    },
    breastSizeList: [
      { name: "Первый", id: apiBreastSize.First },
      { name: "Второй", id: apiBreastSize.Second },
      { name: "Третий", id: apiBreastSize.Third },
      { name: "Четвертый", id: apiBreastSize.Fourth },
      { name: "Пятый и более", id: apiBreastSize.FiveAndMore },
    ],
    sexPeriodicityList: [
      { name: "Ежедневно", id: apiSexPeriodicity.Daily },
      { name: "Раз в неделю", id: apiSexPeriodicity.Weekly },
      { name: "Раз в месяц", id: apiSexPeriodicity.Monthly },
      { name: "Не важно", id: apiSexPeriodicity.NotImportant },
    ],
    sexualOrientationsList: [
      { name: "Гетеро", id: apiSexualOrientation.Hetero },
      { name: "Би", id: apiSexualOrientation.Bio },
    ],
    sexTypesList: safeParseJSON(window.localStorage.sexTypesList, []),
  },
  currentUser: {},
};

const profileReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case actionTypes.SET_FILTER:
      return {
        ...state,
        filter: JSON.parse(
          JSON.stringify({
            ...state.filter,
            ...payload,
          })
        ),
      };
    case actionTypes.SET_USERS_IDS:
      return {
        ...state,
        usersIdsAll: payload.ids,
        hasMoreIds: payload.hasMore,
        loadingMoreIds: false,
        searchGen: state.searchGen + 1,
      };
    case actionTypes.APPEND_USERS_IDS: {
      const have = new Set(state.usersIdsAll.map(String));
      return {
        ...state,
        usersIdsAll: [...state.usersIdsAll, ...payload.ids.filter((id: any) => !have.has(String(id)))],
        hasMoreIds: payload.hasMore,
        loadingMoreIds: false,
      };
    }
    case actionTypes.SET_LOADING_MORE_IDS:
      return { ...state, loadingMoreIds: payload };
    case actionTypes.SET_USERS_PREVIEWS:
      return {
        ...state,
        usersPreviews: payload,
      };
    case actionTypes.SET_USERS_PREVIEWS_BY_PAGE:
      return {
        ...state,
        // без дублей (повторный ответ той же страницы)
        usersPreviews: [
          ...state.usersPreviews,
          ...payload.previews.filter((p: any) => !state.usersPreviews.some((u: any) => u.id === p.id)),
        ],
      };
    case actionTypes.RESET_USERS_FILTER:
      return {
        ...state,
        filter: { ...initialState.filter },
      };
    case actionTypes.SET_LOADING_FILTER:
      return {
        ...state,
        loadingFilter: payload,
      };
    case actionTypes.SET_LOADING_USERS:
      return {
        ...state,
        loadingUsers: payload,
      };
    case actionTypes.SET_LANGUAGES_LIST:
      return {
        ...state,
        selects: {
          ...state.selects,
          languagesList: payload,
        },
      };
    case actionTypes.SET_NATIONALITIES_LIST:
      return {
        ...state,
        selects: {
          ...state.selects,
          nationalitiesList: payload,
        },
      };
    case actionTypes.SET_INTERESTS_LIST:
      return {
        ...state,
        selects: {
          ...state.selects,
          interestsList: payload,
        },
      };
    case actionTypes.SET_LOADING_CURRENT_USER:
      return {
        ...state,
        loadingCurrentUser: payload,
      };
    case actionTypes.SET_USER_INFO:
      return {
        ...state,
        currentUser: payload,
      };
    case actionTypes.SET_USER_BANNED:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          profileBanUser: payload,
        },
      };
    case actionTypes.SET_REQUEST_PRIVATE_PHOTOS_PENDING:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          profileSendRequestUser: payload,
        },
      };
    case actionTypes.SET_SEXTYPES_LIST:
      return {
        ...state,
        selects: {
          ...state.selects,
          sexTypesList: payload,
        },
      };
    case actionTypes.SET_USER_SYSTEM_BLOCKED:
      return {
        ...state,
        currentUser: { systemBlocked: payload },
      };
    case actionTypes.SET_USER_DELETED:
      return {
        ...state,
        currentUser: { deleted: payload }, 
      };
    case actionTypes.SET_USER_NOT_FOUND:
      return {
        ...state,
        currentUser: { notFound: payload },
      };
    default:
      return state;
  }
};

export default profileReducer;
